import Com from "components/styledComp/CommStyledComp";
import React from "react";
import CompImg from "components/comp/CompImg";
import SelfRegisterImg from "assets/images/hygateone/self-register.jpg";
import VipVisitImg from "assets/images/hygateone/vip-visit.jpg";

const HyGateOneAccess = () => {
  return (
    <Com.DivDetailSection border="false" id="access">
      <Com.DivDetailHeading>
        <Com.DetailHeading>Smart Access</Com.DetailHeading>
        <Com.DetailHeadingSmall>
          관리실 방문 없이, 스마트폰으로 완성하는 출입·방문 경험
        </Com.DetailHeadingSmall>
      </Com.DivDetailHeading>
      <div className="strategy-list">
        <div className="strategy">
          <div className="schedule-dogyo">
            <Com.StrongStrategy underline={true}>셀프 얼굴 등록</Com.StrongStrategy>
            <div className="strategy-desc">
              <p>
                신규 입사자·사용자가 스마트폰으로 직접 얼굴을 등록하면<br />
                클라우드에 즉시 연동되어 출입 권한이 활성화됩니다.<br />
                관리자의 물리적 개입을 최소화해 온보딩 리소스를 크게 줄입니다.
              </p>
            </div>
            <CompImg img={SelfRegisterImg} width="100%" height="auto" fit="contain" />
          </div>
        </div>
        <div className="strategy">
          <div className="schedule-dogyo">
            <Com.StrongStrategy underline={true}>VIP 방문 프로세스</Com.StrongStrategy>
            <div className="strategy-desc">
              <p>
                <span>초대: </span>사전 방문 예정자에게 방문 신청 URL을 이메일·문자로 전송<br />
              </p>
              <p>
                <span>등록: </span>방문객이 스마트폰으로 방문 정보를 직접 입력<br />
              </p>
              <p>
                <span>출입: </span>로비 대기·신분증 교환 없이 QR코드로 즉시 프리패스 출입
              </p>
            </div>
            <CompImg img={VipVisitImg} width="100%" height="auto" fit="contain" />
          </div>
        </div>
      </div>
    </Com.DivDetailSection>
  );
};

export default HyGateOneAccess;
